// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, IconNfc, 
    IconUserCircle ,
    IconUsersGroup
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const professeurPortail = {
    id: 'student',
    title: <FormattedMessage id="menu_professor" />,
    type: 'group',
    icon: <IconUsersGroup />, // Use a valid icon component here
    children: [

            {
                id: 'donnees_du_professeur1',
                title: ["1. ", <FormattedMessage id="donnees_du_professeur" />],
                type: 'item',
                url:  '/professor/NewProfEditProfPortal'
            },

            {
                id: 'coursPlan1',
                title: ["2. ", <FormattedMessage id="plandu_cours" />],
                type: 'item',
                url: '/cours/coursPlanProf'
            },

            {
                id: 'lista_presence_digital1',
                title: ["3. ", <FormattedMessage id="lista_presence_digital" />],
                type: 'item',
                url:  '/professor/ListaPreseneDigitalProfApi'
            },

            {
                id: 'horarios1',
                title: ["4. ", <FormattedMessage id="horarios_em_grafico" />],
                type: 'item',
                url:  '/professor/HorarioDoProfesseorProfAPi'
            },

            {
                id: 'LancerPointInterrogrationAntesExame1',
                title: ["5. ", <FormattedMessage id="LancerPointInterrogrationAntesExame" />],
                type: 'item',
                url:  '/notas/LancerPointInterrogrationAntesExameApi'
            },

            {
                id: 'lancerpoint_premiereSession1',
                title: ["6. ", <FormattedMessage id="Lancamento_nnotas_exame" />],
                type: 'item',
                url: '/notas/LancerPointInterrogrationTPProfAPi'
            },
            {
                id: 'lancerpoint_deuxiemeSession1',
                title: ["7. ", <FormattedMessage id="lancerpoint_deuxiemeSession" />],
                type: 'item',
                url: '/notas/LancerPointSession2ProfApi'
                // '/user/social-profile/posts'
            },

            {
                id: 'lancamento_notas_xame_espcial1',
                title: ["8. ", <FormattedMessage id="lancamento_notas_xame_espcial" />],
                type: 'item',
                url: '/notas/LancerPointExameSpecialProfApi'
                // '/user/social-profile/posts'
            },

            {
                id: 'lancerpoint_Stage1',
                title: ["9. ",  <FormattedMessage id="lancerpoint_Stage1" />],
                type: 'item',
              url: '/notas/LancerPointIntStageProfAPi'

                
              //  url: '/notas/LancerPointStage'
                // '/user/social-profile/posts'
            },
            
            {
                id: 'lancerpoint_memoire1',
                title: ["10. ", <FormattedMessage id="lancerpoint_memoire" />],
                type: 'item',
                url: '/notas/LancerPointIntStageProfAPiMemoire'
                // '/user/social-profile/posts'
            },

            
            /* {
                id: 'lancamento_notas_xame_espcial1',
                title: <FormattedMessage id="lancamento_notas_xame_espcial" />,
                type: 'item',
                url: '/notas/LancerPointExamenSpecial'
            }, */

           /*  {
                id: 'lancer_points_examen_special1',
                title: <FormattedMessage id="lancer_points_examen_special" />,
                type: 'item',
                url: '/examen-special'
                // '/user/social-profile/posts'
            }, */

          /*   {
                id: 'lancerpoint_parEclatement',
                title: <FormattedMessage id="enregistrer_points_par_eclatement" />,
                type: 'item',
                url: '/points/par-eclatement'
                // '/user/social-profile/posts'
            }, */

           /*  {
                id: 'examen_choixMultiple_automatique1',
                title: <FormattedMessage id="examen_choixMultiple_automatique" />,
                type: 'item',
                url: '/professeurs/examens/automatiques'
            }, */
/* 
            {
                id: 'resultats_examens_automatiques1',
                title: <FormattedMessage id="resultats_examens_automatiques" />,
                type: 'item',
                url: '#'
            }, */



            
           // ]
       // }
    ]
};

export default professeurPortail;
